import { groupAlternativesByGroup } from './groupAlternativesByGroup';
import { groupAlternativesByEnunciado } from './groupAlternativesByEnunciado';
import { isGradeQuestion } from './isGradeQuestion';

/**
 * Ordem canônica das colunas da tabela: o header, TODOS os tbodies e o footer
 * percorrem esta mesma lista. A decisão é tomada uma única vez, aqui, e a partir
 * da tabela inteira — não de perguntas_cruzadas[0], que era a origem do
 * desalinhamento: a ordem das colunas é propriedade da pergunta principal.
 *
 * Retorna:
 * - groups: [{ label, alternativas }] — label é null quando não há agrupamento
 * - labelKey: o eixo que os tbodies de grade usam para rotular cada coluna,
 *   sempre o complementar ao que agrupa o header
 */
export const getMainColumnGroups = (alternativas, perguntasCruzadas = []) => {
  if (!alternativas?.length) return { groups: [], labelKey: 'enunciado' };

  if (!isGradeQuestion(alternativas)) {
    return { groups: [{ label: null, alternativas }], labelKey: 'enunciado' };
  }

  // Só agrupa por enunciado quando TODAS as cruzadas são de grade — é o layout que o
  // AllQuestionGradeTable já usa hoje. Nos demais casos (todas simples, ou misto) vale
  // o agrupamento por titulo_grade do MainQuestionIsGrade. Assim nenhuma tabela que
  // hoje renderiza certo muda de aparência, e a combinação mista — em que os tbodies
  // discordavam entre si e do header — passa a ter uma ordem única e definida.
  const todasCruzadasSaoGrade = perguntasCruzadas.length > 0
    && perguntasCruzadas.every((pergunta) => isGradeQuestion(pergunta.alternativas));

  const agrupar = todasCruzadasSaoGrade ? groupAlternativesByEnunciado : groupAlternativesByGroup;

  return {
    groups: Object.entries(agrupar(alternativas))
      .map(([label, alternativasDoGrupo]) => ({ label, alternativas: alternativasDoGrupo })),
    labelKey: todasCruzadasSaoGrade ? 'titulo_grade' : 'enunciado',
  };
};
